
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"13","height":"11","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M10.563.469l-1.149 2.82h3.14v1.04h-3.53L8.124 6.53h4.43v1.04h-4.82l-1.118 2.82h-.906l1.14-2.82H3.47l1.258 1.507-.508.43-3.82-3.82v-.5l3.82-3.82.508.429-1.25 1.492H8.53L9.656.47h.906zM2.663 6.53h4.578l.899-2.203H2.68l-.899 1.11.883 1.093z","fill":"currentColor"}})])
          )
        }
      }
    